
import AppHeader from './AppHeader';

export default function Header() {
    
    // Always use the app header now
    return <AppHeader />;
}